import React, { FC } from "react";

import { Icon } from "~/ui";

type Props = {
  title?: string;
  message?: string;
  className?: string;
};

export const NoDataDisplay: FC<Props> = ({
  title = "データがありません",
  message,
  className = "",
}) => {
  return (
    <div
      className={`rounded-xl shadow-xs border border-secondary-200 p-12 text-center ${className}`}
    >
      <Icon
        icon={"ioDocumentTextOutline"}
        size={"4rem"}
        color="text-secondary-400"
        className="mx-auto mb-4"
      />
      <h3 className="text-lg font-semibold text-secondary-900 mb-2">{title}</h3>
      {message && <p className="text-secondary-600">{message}</p>}
    </div>
  );
};
